import _typeof from "@babel/runtime/helpers/typeof";
export var pick = function pick(target) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (!(_typeof(target) === 'object' && Array.isArray(keys))) {
    return {};
  }

  return keys.reduce(function (obj, key) {
    if (target && target.hasOwnProperty(key)) {
      obj[key] = target[key];
    }

    return obj;
  }, {});
};